module.exports = __webpack_public_path__ + "static/media/spanish-flag-large.944aafdf.png";